import React from 'react';

import useRdmdOpts from '@core/hooks/useRdmdOpts';
import classy from '@core/utils/classy';
import { htmlBlock } from '@core/utils/magicBlocks';

import RDMD from '@ui/RDMD';

import styles from '../style.module.scss';

interface HtmlBlockProps {
  className?: string;
  html: string;
}

function HtmlBlock({ html, className = '' }: HtmlBlockProps) {
  const rdmdOpts = useRdmdOpts();

  return (
    <RDMD
      className={classy(styles.LandingBlock, styles['LandingBlock-Html'], className)}
      opts={rdmdOpts}
      renderer="rdmd"
    >
      {htmlBlock(html)}
    </RDMD>
  );
}

export default HtmlBlock;
